(() => {
  'use strict';

  if (window.GTEmptyCartBrowseLoaded) {
    return;
  }

  window.GTEmptyCartBrowseLoaded = true;

  const SELECTORS = {
    carousel: '[data-empty-cart-carousel]',
    viewport: '[data-empty-cart-viewport]',
    card: '[data-empty-cart-card]',
    counter: '[data-empty-cart-counter]',
    arrow: '[data-empty-cart-scroll]',
    addButton: '[data-empty-cart-add]',
    variant: '[data-empty-cart-variant]',
    status: '[data-empty-cart-status]',
  };

  const STYLE_ID = 'GTEmptyCartBrowseStyles';

  let resizeTimer = null;

  /* ======================================================
     EMPTY-CART DESIGN
     Matches the populated cart recommendation styling.
     ====================================================== */

  function injectStyles() {
    const existingStyle = document.getElementById(STYLE_ID);

    if (existingStyle) {
      existingStyle.remove();
    }

    const style = document.createElement('style');

    style.id = STYLE_ID;

    style.textContent = `
      /* ==================================================
         EMPTY CART BODY
         ================================================== */

      html body cart-drawer.is-empty .drawer__inner {
        background: #ffffff !important;
      }

      html body cart-drawer.is-empty .drawer__inner-empty {
        background: #ffffff !important;
      }

      html body cart-drawer.is-empty .cart-drawer__empty-content {
        padding:
          22px
          0
          calc(28px + env(safe-area-inset-bottom)) !important;
      }

      /* ==================================================
         EMPTY CART HERO
         ================================================== */

      html body cart-drawer.is-empty .gt-empty-cart-hero {
        width: auto !important;
        margin: 0 18px 22px !important;
        padding: 22px 20px 24px !important;
        background: #ffffff !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        text-align: center !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-hero__icon {
        width: 64px !important;
        height: 64px !important;
        margin: 0 auto 13px !important;
        color: #1d5637 !important;
        background: #eef1eb !important;
        border: 0 !important;
        box-shadow: none !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-hero__icon svg {
        width: 31px !important;
        height: 31px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-hero__heading {
        margin: 0 !important;
        color: #353027 !important;
        font-size: 24px !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-hero__text {
        max-width: 350px !important;
        margin: 9px auto 17px !important;
        color: #66625d !important;
        font-size: 16px !important;
        line-height: 1.45 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-hero__button.button {
        min-width: 220px !important;
        min-height: 48px !important;
        padding: 0 22px !important;
        color: #ffffff !important;
        background: #1d5637 !important;
        border: 0 !important;
        border-radius: 8px !important;
        box-shadow: none !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        letter-spacing: 0 !important;
        text-transform: none !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-hero__button.button:hover {
        color: #ffffff !important;
        background: #17472e !important;
      }

      /* ==================================================
         RECOMMENDATION SECTIONS

         Same light-grey treatment as the populated cart's
         "You may also like" area.
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel {
        width: 100% !important;
        margin: 0 !important;
        padding: 20px 18px 18px !important;
        overflow: hidden !important;
        color: #353027 !important;
        background: #f4f4f4 !important;
        border: 0 !important;
        border-top: 1px solid #e5e5e5 !important;
        border-bottom: 1px solid #e5e5e5 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel
        + .gt-empty-cart-carousel {
        margin-top: 14px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__header {
        display: flex !important;
        align-items: center !important;
        justify-content: space-between !important;
        gap: 12px !important;
        margin: 0 0 15px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__heading-group {
        min-width: 0 !important;
        padding: 0 !important;
        border: 0 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__heading {
        margin: 0 !important;
        color: #353027 !important;
        font-size: 20px !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__subheading {
        margin: 4px 0 0 !important;
        color: #66625d !important;
        font-size: 13px !important;
        line-height: 1.3 !important;
      }

      /* ==================================================
         COUNTER AND ARROWS
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__controls {
        display: flex !important;
        flex: 0 0 auto !important;
        align-items: center !important;
        gap: 4px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__counter {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        min-width: 58px !important;
        min-height: 34px !important;
        padding: 5px 10px !important;
        color: #353027 !important;
        background: #ffffff !important;
        border: 1px solid #dedede !important;
        border-radius: 999px !important;
        box-shadow: none !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        font-variant-numeric: tabular-nums !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__arrow {
        display: grid !important;
        place-items: center !important;
        width: 35px !important;
        min-width: 35px !important;
        height: 35px !important;
        min-height: 35px !important;
        margin: 0 !important;
        padding: 0 !important;
        color: #353027 !important;
        background: transparent !important;
        border: 0 !important;
        border-radius: 50% !important;
        box-shadow: none !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__arrow:hover:not(:disabled) {
        color: #1d5637 !important;
        background: rgba(29, 86, 55, 0.07) !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__arrow:disabled {
        color: #9a9894 !important;
        opacity: 0.4 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__arrow svg {
        width: 11px !important;
        height: 7px !important;
      }

      /* ==================================================
         HORIZONTAL SCROLLER
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__viewport {
        width: 100% !important;
        overflow-x: auto !important;
        overflow-y: visible !important;
        scroll-behavior: smooth !important;
        scroll-snap-type: x proximity !important;
        overscroll-behavior-x: contain !important;
        overscroll-behavior-y: auto !important;
        scrollbar-width: none !important;
        -webkit-overflow-scrolling: touch !important;
        touch-action: pan-x pan-y pinch-zoom !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__viewport *,
      html body cart-drawer.is-empty
        .gt-empty-cart-card {
        touch-action: pan-x pan-y pinch-zoom !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__viewport::-webkit-scrollbar {
        display: none !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__track {
        display: flex !important;
        align-items: stretch !important;
        gap: 12px !important;
        width: max-content !important;
      }

      /* ==================================================
         PRODUCT CARDS

         Replicates the populated cart recommendation card:
         image left, title and variant in the centre, price
         and compact add button on the right.
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-card {
        flex: 0 0 calc(100% - 34px) !important;
        display: grid !important;
        grid-template-columns:
          82px
          minmax(0, 1fr)
          auto !important;
        grid-template-rows:
          auto
          auto !important;
        align-items: start !important;
        gap: 8px 12px !important;
        width: calc(100% - 34px) !important;
        max-width: 390px !important;
        min-width: 310px !important;
        min-height: 108px !important;
        margin: 0 !important;
        padding: 12px !important;
        color: #353027 !important;
        background: #ffffff !important;
        border: 1px solid rgba(53, 48, 39, 0.08) !important;
        border-radius: 12px !important;
        box-shadow: none !important;
        scroll-snap-align: start !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__image-link {
        grid-column: 1 !important;
        grid-row: 1 / 3 !important;
        display: block !important;
        width: 82px !important;
        height: 82px !important;
        overflow: hidden !important;
        background: #f1eee9 !important;
        border-radius: 9px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__image {
        display: block !important;
        width: 100% !important;
        height: 100% !important;
        object-fit: cover !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__content {
        grid-column: 2 / 4 !important;
        grid-row: 1 !important;
        display: grid !important;
        grid-template-columns:
          minmax(0, 1fr)
          auto !important;
        align-items: start !important;
        gap: 8px !important;
        min-width: 0 !important;
        margin: 0 !important;
        padding: 0 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__title {
        grid-column: 1 !important;
        display: block !important;
        min-width: 0 !important;
        margin: 0 !important;
        color: #353027 !important;
        font-size: 15px !important;
        font-weight: 500 !important;
        line-height: 1.32 !important;
        text-decoration: none !important;
        overflow-wrap: anywhere !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__title:hover {
        color: #1d5637 !important;
        text-decoration: underline !important;
        text-underline-offset: 2px !important;
      }

      /*
        Hide product-level compare-at pricing because it may
        belong to a different variant.
      */

      html body cart-drawer.is-empty
        .gt-empty-cart-card__price s {
        display: none !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__price {
        grid-column: 2 !important;
        display: block !important;
        min-width: max-content !important;
        margin: 0 !important;
        color: #353027 !important;
        line-height: 1.2 !important;
        text-align: right !important;
        white-space: nowrap !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__price strong,
      html body cart-drawer.is-empty
        .gt-empty-cart-card__selected-price {
        color: #353027 !important;
        font-size: 16px !important;
        font-weight: 700 !important;
        line-height: 1.2 !important;
        letter-spacing: 0 !important;
      }

      /* ==================================================
         VARIANT SELECTOR
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-card__variant-area {
        grid-column: 2 !important;
        grid-row: 2 !important;
        align-self: end !important;
        min-width: 0 !important;
        margin: 0 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__variant {
        display: block !important;
        width: auto !important;
        max-width: 100% !important;
        height: 30px !important;
        min-height: 30px !important;
        margin: 0 !important;
        padding: 0 24px 0 0 !important;
        color: #5f5c57 !important;
        background-color: transparent !important;
        border: 0 !important;
        border-radius: 0 !important;
        box-shadow: none !important;
        font-family:
          var(--font-body-family),
          Arial,
          sans-serif !important;
        font-size: 13px !important;
        line-height: 1.3 !important;
        cursor: pointer !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__variant:hover {
        color: #1d5637 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__variant:focus {
        outline: 2px solid rgba(29, 86, 55, 0.16) !important;
        outline-offset: 2px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__single-variant {
        display: block !important;
        color: #5f5c57 !important;
        font-size: 13px !important;
        line-height: 1.3 !important;
      }

      /* ==================================================
         ADD BUTTON

         Same pale-green compact pill used by populated
         recommendation cards.
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-card__add {
        position: relative !important;
        grid-column: 3 !important;
        grid-row: 2 !important;
        align-self: end !important;
        justify-self: end !important;
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        width: auto !important;
        min-width: 76px !important;
        min-height: 34px !important;
        margin: 0 !important;
        padding: 7px 14px !important;
        color: #1d5637 !important;
        background: #eaf1eb !important;
        border: 0 !important;
        border-radius: 999px !important;
        box-shadow: none !important;
        font-family:
          var(--font-body-family),
          Arial,
          sans-serif !important;
        font-size: 13px !important;
        font-weight: 700 !important;
        line-height: 1 !important;
        white-space: nowrap !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__add:hover:not(:disabled) {
        color: #ffffff !important;
        background: #1d5637 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__add:focus-visible {
        outline: 2px solid #1d5637 !important;
        outline-offset: 2px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__add:disabled {
        opacity: 0.7 !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-card__add-spinner {
        border-color: rgba(29, 86, 55, 0.25) !important;
        border-top-color: #1d5637 !important;
      }

      /* ==================================================
         VIEW-ALL LINK
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__footer {
        margin: 15px 0 0 !important;
        padding: 0 !important;
        border: 0 !important;
        text-align: center !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__view-all {
        color: #1d5637 !important;
        font-size: 14px !important;
        font-weight: 700 !important;
        text-underline-offset: 3px !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__view-all:hover {
        color: #17472e !important;
      }

      html body cart-drawer.is-empty
        .gt-empty-cart-carousel__status {
        margin: 8px 0 0 !important;
        color: #a02727 !important;
        font-size: 13px !important;
        font-weight: 600 !important;
      }

      /* ==================================================
         LOGIN PANEL
         ================================================== */

      html body cart-drawer.is-empty
        .gt-empty-cart-login {
        width: auto !important;
        margin: 18px 18px 0 !important;
        padding: 18px !important;
        background: #ffffff !important;
        border: 1px solid rgba(53, 48, 39, 0.1) !important;
        border-radius: 12px !important;
        box-shadow: none !important;
        text-align: center !important;
      }

      /* ==================================================
         MOBILE
         ================================================== */

      @media screen and (max-width: 749px) {
        html body cart-drawer.is-empty
          .cart-drawer__empty-content {
          padding:
            18px
            0
            calc(24px + env(safe-area-inset-bottom)) !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-hero {
          margin:
            0
            14px
            18px !important;
          padding:
            20px
            16px
            22px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-hero__heading {
          font-size: 22px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-hero__text {
          font-size: 15px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-hero__button.button {
          min-height: 46px !important;
          font-size: 15px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-carousel {
          padding:
            18px
            14px
            17px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-carousel__heading {
          font-size: 18px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-carousel__subheading {
          font-size: 12px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-carousel__counter {
          min-width: 54px !important;
          min-height: 32px !important;
          font-size: 13px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-carousel__arrow {
          width: 32px !important;
          min-width: 32px !important;
          height: 32px !important;
          min-height: 32px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card {
          flex-basis: calc(100vw - 68px) !important;
          width: calc(100vw - 68px) !important;
          max-width: 380px !important;
          min-width: 290px !important;
          grid-template-columns:
            82px
            minmax(0, 1fr)
            auto !important;
          gap: 7px 10px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card__title {
          font-size: 15px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card__price strong,
        html body cart-drawer.is-empty
          .gt-empty-cart-card__selected-price {
          font-size: 16px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card__variant {
          font-size: 12.5px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-login {
          margin-right: 14px !important;
          margin-left: 14px !important;
        }
      }

      @media screen and (max-width: 390px) {
        html body cart-drawer.is-empty
          .gt-empty-cart-carousel__header {
          align-items: flex-start !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card {
          flex-basis: calc(100vw - 58px) !important;
          width: calc(100vw - 58px) !important;
          min-width: 280px !important;
          grid-template-columns:
            76px
            minmax(0, 1fr)
            auto !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card__image-link {
          width: 76px !important;
          height: 76px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card__title {
          font-size: 14px !important;
        }

        html body cart-drawer.is-empty
          .gt-empty-cart-card__add {
          min-width: 68px !important;
          padding-right: 11px !important;
          padding-left: 11px !important;
          font-size: 12.5px !important;
        }
      }

      @media (prefers-reduced-motion: reduce) {
        html body cart-drawer.is-empty
          .gt-empty-cart-carousel__viewport {
          scroll-behavior: auto !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  /* ======================================================
     PRICE CORRECTION
     ====================================================== */

  function getSelectedVariantPrice(select) {
    if (!select) {
      return '';
    }

    const selectedOption = select.options[select.selectedIndex];

    if (!selectedOption) {
      return '';
    }

    if (selectedOption.dataset.price) {
      return selectedOption.dataset.price.trim();
    }

    const optionText = selectedOption.textContent
      .replace(/\s+/g, ' ')
      .trim();

    const separatorIndex = optionText.lastIndexOf('·');

    if (separatorIndex !== -1) {
      return optionText
        .slice(separatorIndex + 1)
        .trim()
        .replace(/\s+/g, '');
    }

    const priceMatches = optionText.match(
      /(?:A\$|\$)\s?[\d,]+(?:\.\d{2})?/g
    );

    if (priceMatches?.length) {
      return priceMatches[
        priceMatches.length - 1
      ].replace(/\s+/g, '');
    }

    return '';
  }

  function normaliseCardPrice(card) {
    if (!card) {
      return;
    }

    const priceContainer = card.querySelector(
      '.gt-empty-cart-card__price'
    );

    if (!priceContainer) {
      return;
    }

    const currentPrice = priceContainer.querySelector('strong');

    const crossedOutPrices = priceContainer.querySelectorAll('s');

    crossedOutPrices.forEach((crossedOutPrice) => {
      crossedOutPrice.hidden = true;
      crossedOutPrice.setAttribute('aria-hidden', 'true');
    });

    if (!currentPrice) {
      return;
    }

    const variantSelect = card.querySelector(SELECTORS.variant);

    const selectedVariantPrice =
      getSelectedVariantPrice(variantSelect);

    if (selectedVariantPrice) {
      currentPrice.textContent = selectedVariantPrice;
    } else {
      currentPrice.textContent = currentPrice.textContent
        .replace(/^From\s*/i, '')
        .replace(/\s+/g, '')
        .trim();
    }

    currentPrice.classList.add(
      'gt-empty-cart-card__selected-price'
    );

    priceContainer.setAttribute('aria-live', 'polite');
  }

  function normaliseCarouselPrices(carousel) {
    carousel
      .querySelectorAll(SELECTORS.card)
      .forEach(normaliseCardPrice);
  }

  /* ======================================================
     CAROUSEL CONTROLS
     ====================================================== */

  function getCards(carousel) {
    return Array.from(
      carousel.querySelectorAll(SELECTORS.card)
    );
  }

  function getNearestCardIndex(viewport, cards) {
    if (!cards.length) {
      return 0;
    }

    const currentScroll = viewport.scrollLeft;

    let nearestIndex = 0;
    let nearestDistance = Number.POSITIVE_INFINITY;

    cards.forEach((card, index) => {
      const distance = Math.abs(
        card.offsetLeft - currentScroll
      );

      if (distance < nearestDistance) {
        nearestDistance = distance;
        nearestIndex = index;
      }
    });

    return nearestIndex;
  }

  function updateCarousel(carousel) {
    const viewport = carousel.querySelector(
      SELECTORS.viewport
    );

    const counter = carousel.querySelector(
      SELECTORS.counter
    );

    const arrows = Array.from(
      carousel.querySelectorAll(SELECTORS.arrow)
    );

    const cards = getCards(carousel);

    if (!viewport || !cards.length) {
      if (counter) {
        counter.textContent = '0 / 0';
      }

      arrows.forEach((arrow) => {
        arrow.disabled = true;
      });

      return;
    }

    const currentIndex = getNearestCardIndex(
      viewport,
      cards
    );

    const maximumScroll = Math.max(
      0,
      viewport.scrollWidth - viewport.clientWidth
    );

    if (counter) {
      counter.textContent =
        `${currentIndex + 1} / ${cards.length}`;
    }

    arrows.forEach((arrow) => {
      const direction = Number(
        arrow.dataset.emptyCartScroll || 0
      );

      if (direction < 0) {
        arrow.disabled =
          currentIndex <= 0 ||
          viewport.scrollLeft <= 2;
      } else {
        arrow.disabled =
          currentIndex >= cards.length - 1 ||
          viewport.scrollLeft >= maximumScroll - 2;
      }
    });
  }

  function initialiseCarousel(carousel) {
    const viewport = carousel.querySelector(
      SELECTORS.viewport
    );

    if (!viewport) {
      return;
    }

    normaliseCarouselPrices(carousel);

    if (
      viewport.dataset.emptyCartInitialised !== 'true'
    ) {
      viewport.dataset.emptyCartInitialised = 'true';

      viewport.addEventListener(
        'scroll',
        () => {
          window.requestAnimationFrame(() => {
            updateCarousel(carousel);
          });
        },
        { passive: true }
      );
    }

    updateCarousel(carousel);
  }

  function initialiseAllCarousels(root = document) {
    injectStyles();

    root
      .querySelectorAll(SELECTORS.carousel)
      .forEach(initialiseCarousel);
  }

  function getCarouselStep(carousel) {
    const viewport = carousel.querySelector(
      SELECTORS.viewport
    );

    const card = carousel.querySelector(
      SELECTORS.card
    );

    const track = viewport?.firstElementChild;

    if (!viewport || !card) {
      return 280;
    }

    let gap = 12;

    if (track) {
      const trackStyles = window.getComputedStyle(track);

      const parsedGap = Number.parseFloat(
        trackStyles.columnGap || trackStyles.gap
      );

      if (Number.isFinite(parsedGap)) {
        gap = parsedGap;
      }
    }

    return card.getBoundingClientRect().width + gap;
  }

  function handleCarouselArrow(button) {
    const carousel = button.closest(
      SELECTORS.carousel
    );

    const viewport = carousel?.querySelector(
      SELECTORS.viewport
    );

    if (!carousel || !viewport || button.disabled) {
      return;
    }

    const direction = Number(
      button.dataset.emptyCartScroll || 0
    );

    viewport.scrollBy({
      left: direction * getCarouselStep(carousel),
      behavior: 'smooth',
    });
  }

  /* ======================================================
     STATUS AND BUTTON LOADING
     ====================================================== */

  function showStatus(carousel, message, isError = false) {
    const status = carousel?.querySelector(
      SELECTORS.status
    );

    if (!status) {
      return;
    }

    status.textContent = message;

    status.classList.toggle(
      'is-error',
      isError
    );
  }

  function setAddButtonLoading(button, loading) {
    button.classList.toggle('is-loading', loading);
    button.disabled = loading;

    button.setAttribute(
      'aria-busy',
      loading ? 'true' : 'false'
    );
  }

  function getSelectedVariantId(button) {
    const card = button.closest(SELECTORS.card);

    const variantSelect = card?.querySelector(
      SELECTORS.variant
    );

    if (variantSelect?.value) {
      return variantSelect.value;
    }

    return button.dataset.variantId || '';
  }

  /* ======================================================
     SHOPIFY CART REQUEST
     ====================================================== */

  function getCartSections(drawer) {
    if (
      drawer &&
      typeof drawer.getSectionsToRender === 'function'
    ) {
      const sections = drawer
        .getSectionsToRender()
        .map((section) => section.id)
        .filter(Boolean);

      if (sections.length) {
        return sections;
      }
    }

    return [
      'cart-drawer',
      'cart-icon-bubble',
    ];
  }

  function getFetchConfiguration(formData) {
    let configuration;

    if (typeof window.fetchConfig === 'function') {
      configuration = window.fetchConfig('javascript');

      if (configuration.headers) {
        delete configuration.headers['Content-Type'];
      }
    } else if (typeof fetchConfig === 'function') {
      configuration = fetchConfig('javascript');

      if (configuration.headers) {
        delete configuration.headers['Content-Type'];
      }
    } else {
      configuration = {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
      };
    }

    configuration.method = 'POST';
    configuration.body = formData;

    return configuration;
  }

  async function addEmptyCartProduct(button) {
    if (button.disabled) {
      return;
    }

    const carousel = button.closest(
      SELECTORS.carousel
    );

    const variantId = getSelectedVariantId(button);

    if (!variantId) {
      showStatus(
        carousel,
        'Please choose a product option.',
        true
      );

      return;
    }

    setAddButtonLoading(button, true);
    showStatus(carousel, '');

    const drawer = document.querySelector('cart-drawer');

    const formData = new FormData();

    formData.append('id', variantId);
    formData.append('quantity', '1');

    formData.append(
      'sections',
      getCartSections(drawer).join(',')
    );

    formData.append(
      'sections_url',
      window.location.pathname
    );

    const cartAddUrl =
      window.routes?.cart_add_url ||
      `${window.Shopify?.routes?.root || '/'}cart/add.js`;

    try {
      const response = await fetch(
        cartAddUrl,
        getFetchConfiguration(formData)
      );

      const cartResponse = await response.json();

      if (!response.ok || cartResponse.status) {
        throw new Error(
          cartResponse.description ||
          cartResponse.message ||
          'This product could not be added.'
        );
      }

      if (
        drawer &&
        typeof drawer.renderContents === 'function' &&
        cartResponse.sections
      ) {
        drawer.renderContents(cartResponse);
      } else {
        window.location.assign(
          window.routes?.cart_url || '/cart'
        );

        return;
      }

      if (
        typeof window.publish === 'function' &&
        window.PUB_SUB_EVENTS?.cartUpdate
      ) {
        window.publish(
          window.PUB_SUB_EVENTS.cartUpdate,
          {
            source: 'gt-empty-cart-browse',
            productVariantId: variantId,
            cartData: cartResponse,
          }
        );
      }
    } catch (error) {
      console.error(
        'Goodness Tea empty-cart add error:',
        error
      );

      showStatus(
        carousel,
        error instanceof Error
          ? error.message
          : 'This product could not be added. Please try again.',
        true
      );
    } finally {
      if (button.isConnected) {
        setAddButtonLoading(button, false);
      }
    }
  }

  /* ======================================================
     EVENTS
     ====================================================== */

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest(
      SELECTORS.arrow
    );

    if (arrow) {
      event.preventDefault();
      handleCarouselArrow(arrow);
      return;
    }

    const addButton = event.target.closest(
      SELECTORS.addButton
    );

    if (addButton) {
      event.preventDefault();
      event.stopPropagation();

      addEmptyCartProduct(addButton);
    }
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest(
      SELECTORS.variant
    );

    if (!variantSelect) {
      return;
    }

    const card = variantSelect.closest(
      SELECTORS.card
    );

    const addButton = card?.querySelector(
      SELECTORS.addButton
    );

    if (addButton) {
      addButton.dataset.variantId =
        variantSelect.value;
    }

    normaliseCardPrice(card);
  });

  window.addEventListener(
    'resize',
    () => {
      window.clearTimeout(resizeTimer);

      resizeTimer = window.setTimeout(() => {
        initialiseAllCarousels();
      }, 100);
    },
    { passive: true }
  );

  /* ======================================================
     HANDLE CART-DRAWER HTML REPLACEMENT
     ====================================================== */

  const observer = new MutationObserver((mutations) => {
    let shouldInitialise = false;

    for (const mutation of mutations) {
      for (const addedNode of mutation.addedNodes) {
        if (!(addedNode instanceof Element)) {
          continue;
        }

        if (
          addedNode.matches?.(SELECTORS.carousel) ||
          addedNode.querySelector?.(SELECTORS.carousel)
        ) {
          shouldInitialise = true;
          break;
        }
      }

      if (shouldInitialise) {
        break;
      }
    }

    if (shouldInitialise) {
      window.requestAnimationFrame(() => {
        initialiseAllCarousels();
      });
    }
  });

  function start() {
    initialiseAllCarousels();

    if (document.body) {
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      start,
      { once: true }
    );
  } else {
    start();
  }
})();